// extracted by mini-css-extract-plugin
export default {"bigblue":"mystyle_bigblue__-A7pv"};